// bao migrate skip
import template from "./favourite-control-template.html";
import * as FavoriteControl from "./favourite-control-module";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";

//Favorite Control ViewModel
export default {
    viewModel: {
        createViewModel: (params, componentInfo) => {
            let e = componentInfo.element;
            let vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    Bao.unbindEvent('table-control:load', vm.loadTableControlData);
                }
            });
            vm = new FavoriteControl.FavoriteControlComponent(params);
            vm.init();
            return vm;
        }
    },
    template: template
};